import { CONFIG } from "~/constants/config"
const prefix = "/autopilot"
import { MenuTree } from "~/types/menu"

export const MenuAutopilot: MenuTree = {
  home: {
    name: "Dashboard",
    icon: "mdi-view-dashboard",
    order: 0,
    children: {
      datail: {
        name: "Dashboard",
        icon: "mdi-view-dashboard",
        to: prefix,
        permission_key: "home_dashboard",
      },
    },
  },
}
